import { render } from "./userAdd.vue?vue&type=template&id=5136772f"
import script from "./userAdd.vue?vue&type=script&lang=js"
export * from "./userAdd.vue?vue&type=script&lang=js"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__